import "./assignee";
import "./requester";
import "./queue";
import "./priority";
import "./company";
import "./source";

import { GROUP_REGISTRY } from "./base";

export type { GroupDescriptor } from "./base";

export default GROUP_REGISTRY;
